import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import {
  DetailWrapper,
  DetailsLabel,
  DetailsLayout,
  DetailsTitle,
} from '../../common';

function AllergyDetails({ date, comments, reaction, type, actions }) {
  return (
    <DetailsLayout>
      {type ? (
        <DetailsTitle>{type}</DetailsTitle>
      ) : (
        <DetailsTitle>Unidentified Allergy</DetailsTitle>
      )}
      {reaction && (
        <DetailWrapper>
          <DetailsLabel>Reaction(s):</DetailsLabel>
          {reaction}
        </DetailWrapper>
      )}
      {date && (
        <DetailWrapper>
          <DetailsLabel>Date of Last Reaction(s):</DetailsLabel>
          {date}
        </DetailWrapper>
      )}
      {date && (
        <DetailWrapper>
          <DetailsLabel>Action(s) to Take:</DetailsLabel>
          {actions}
        </DetailWrapper>
      )}
      {comments && (
        <DetailWrapper>
          <DetailsLabel>Notes: </DetailsLabel>
          {comments}
        </DetailWrapper>
      )}
    </DetailsLayout>
  );
}

AllergyDetails.propTypes = {
  actions: PropTypes.string,
  comments: PropTypes.string,
  date: PropTypes.string,
  reaction: PropTypes.string,
  type: PropTypes.string,
};

export default AllergyDetails;



// WEBPACK FOOTER //
// ./src/modules/AllergyPage/components/AllergyDetails.js